// Modalidades de "Citas en Directo" que se muestran de forma informativa.
// Más adelante esta información podrá administrarse desde el panel administrador.
export const directAppointmentList = [
  {
    id: 'beyond-consultas',
    brand: 'Beyond Consultas',
    title: 'Terapias Online',
    image: 'logo-beyond-consultas.png',
    imageAlt: 'Beyond Consultas',
    description:
      'Consultas y terapias online guiadas por nuestros especialistas, disponibles en tres idiomas: español, inglés y portugués, para acompañarte estés donde estés.',
  },
  {
    id: 'abrazando-inclusion',
    brand: 'Fundación Abrazando la Inclusión',
    title: 'Terapias Presenciales',
    image: 'logo-abrazando-inclusion.png',
    imageAlt: 'Fundación Abrazando la Inclusión',
    description:
      'Consultas y terapias presenciales y personalizadas, en un espacio cálido e inclusivo pensado para el bienestar de cada persona y de su familia.',
  },
  {
    id: 'therappy',
    brand: 'TherAppy+',
    title: 'Terapias desde tu celular',
    image: 'logo-therappy.png',
    imageAlt: 'TherAppy+',
    description:
      'Disfruta de terapias online desde tu celular, guiadas por nuestro avatar Lice, que te da indicaciones paso a paso para alcanzar los logros deseados.',
  },
];
